/**
 * AchievementStandardEntry — textarea 아래 "성취기준 찾기" 진입 행 (docs/achievement_standards_ux.md D2)
 *
 * 같은 폼의 "학교평가운영계획 첨부" 행과 같은 인라인 점선 버튼 패턴이다.
 * 단일 생성(교과·교과_고등) 두 곳과 일괄 생성 필드가 공용으로 쓴다.
 *   - hint   : 버튼 옆 보조 문구(일괄 생성 "모든 학생에게 공통으로 들어가요")
 *   - notice : 기록 복원 안내("성취기준 N개는 현재 데이터에 없어 제외했습니다")
 */

import React from 'react';
import './AchievementStandardEntry.css';

const SearchIcon = () => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="14"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    width="14"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
);

const AchievementStandardEntry = ({
  hint,
  notice,
  onOpen,
  testId = 'asp-open',
}) => (
  <div className="asp-entry">
    <div className="asp-entry__row">
      <button
        className="asp-entry__btn"
        data-testid={testId}
        onClick={onOpen}
        type="button"
      >
        <SearchIcon />
        <span>
          <b>성취기준</b>
          {' '}
          찾기
        </span>
      </button>
      {hint ? <span className="asp-entry__hint">{hint}</span> : null}
    </div>
    {notice ? (
      <p className="asp-restore-notice" data-testid="asp-restore-notice">{notice}</p>
    ) : null}
  </div>
);

export default AchievementStandardEntry;
